// firebase.js (CHAT ONLY)
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const chatConfig = {
  apiKey: "AIzaSyCgE0ximVLlUl60PU-lBzwpEq_Z1SYyQsw",
  authDomain: "partech-466310.firebaseapp.com",
  projectId: "partech-466310",
  storageBucket: "partech-466310.firebasestorage.app",
  messagingSenderId: "324443814960",
  appId: "1:324443814960:web:6737ecdb6120d9dc5381f5",
  measurementId: "G-F2HF5NH64N",
};

// تلافي التكرار مع HMR/Next
export const chatApp =
  getApps().find(a => a.name === "[DEFAULT]") ?? initializeApp(chatConfig);

export const db = getFirestore(chatApp);
export const storage = getStorage(chatApp);

// ملاحظة: لا تستورد/تستخدم getMessaging هنا إطلاقًا.
